/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { AutoTaskActionTypes } from '../../action/auto_action/AutoTaskActions'
import { AutoActionTaskConfigState } from '../state/AutoActionTaskConfigState'

class AutoActionTaskStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new AutoActionTaskConfigState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AutoTaskActionTypes.fetchRooms:
        return state

      case AutoTaskActionTypes.fetchOne:
        return state.mergeModel(payload)

      case AutoTaskActionTypes.onCreate:
        return state.clear()

      case AutoTaskActionTypes.onEdit:
        return state.updateValue(payload.name, payload.value)

      default:
        return state
    }
  }
}

export default new AutoActionTaskStore()
